import { render } from "./AvgSpendTotalCard.vue?vue&type=template&id=e99159ee"
import script from "./AvgSpendTotalCard.vue?vue&type=script&lang=js"
export * from "./AvgSpendTotalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__